<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-model="mounting" />
  </router-view>
</template>

<script lang="ts" setup>
import {computed, unref, watch} from 'vue';
import {useRoute, RouterView, onBeforeRouteUpdate} from 'vue-router';
import { useFetchQuery } from '@hooks/fetch';
import { syncHeader } from '@components/structure/navigation/injects';
import { syncPageBusy } from '@utils/busy/injects';
import type { Mounting } from '@/entities/Entities';
import {useI18n} from 'vue-i18n';

const route = useRoute();
const { data: mounting, loading } = useFetchQuery<Mounting>(
  `/mountings/${route.params.mountingId}`,
);

const resyncEvent = (component: any) => (component.type.emits?.includes('resync') ? 'resync' : '');

syncPageBusy(loading);

const { t } = useI18n();

const title = computed(() => `${mounting.value?.address === '' ? t('mounting.home') : mounting.value?.address}`);

const updateFn = (newMounting: Mounting | null) => ({
  extraBreadcrumbs: [
    computed(() => ({
      label: title.value,
      link: `/mountings/${mounting.value?.id}`,
    })),
  ],
  title: computed(() => ({
    text: title.value,
    link: { name: 'mountings-active' },
  })),
});

syncHeader(mounting, updateFn);
</script>

<style lang="scss" scoped></style>
